import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import * as XLSX from 'xlsx';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-registration-report-granth-very-briefly',
  templateUrl: './registration-report-granth-very-briefly.component.html',
  styleUrl: './registration-report-granth-very-briefly.component.scss'
})
export class RegistrationReportGranthVeryBrieflyComponent {
  // ---- Filter / request params (passed via dialog data) ----
  start_date = '';
  end_date = '';
  rep_name = '';
  off_rep_name = '';
  issue_cat = '';
  issue_date = '';

  // ---- Header info ----
  today: Date;
  today1: string;
  issuedatepp: any;
  newissuedatepp: any;

  // ---- Main (first) table data ----
  inDetailsRegReportbtoff101: any[] = [];

  // Grand totals shown in first table footer
  advtamtb: number = 0;
  totaladvtamt: number = 0;
  totalbeforegst_amt: number = 0;
  totalgst: number = 0;
  netadvtamt: number = 0;
  jamatotal: number = 0;
  jamatotalb: number = 0;
  totalCopiesSum: number = 0;
  totalBookPriceSum: number = 0;
  totalSalePriceSum: number = 0;
  totalShippingSum: number = 0;

  // ---- Second page (Off-Representative summary) table data ----
  inDetailsRegReportbtoff: any[] = [];
  gsiValues: any[] = [];
  totalUdhistha: number = 0;
  regularTotalAmt: number = 0;

  officeRepData: any = null;
  officeAdvt: number = 0;
  officeTotalAmt: number = 0;

  magil_varshachi_aajchi_stithi: number = 0;
  magil_varshyachya_ekun_jahirata: number = 0;

  constructor(
    private dialogref: MatDialogRef<RegistrationReportGranthVeryBrieflyComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    this.start_date = this.data['startDate'];
    this.end_date = this.data['endDate'];
    this.rep_name = this.data['rep_name'];
    this.off_rep_name = this.data['off_rep_name'];
    this.newissuedatepp = this.data['newissuedatepp'];
    this.issuedatepp = this.data['issuedatepp'];
    this.issue_cat = this.data['issue_cat'] === undefined ? '' : this.data['issue_cat'];
    this.issue_date = this.data['issueDates'] === undefined ? '' : this.data['issueDates'];

    this.today = new Date();
    this.today1 = this.datePipe.transform(this.today, 'dd-MM-yyyy');

    this.getReportData();
    this.calculateTotalUdhistha();
  }

  private parseNum(v: any): number {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    let s = String(v).replace(/[,₹\s%]/g, '').replace(/[^\d.-]/g, '');
    return s === '' ? 0 : (parseFloat(s) || 0);
  }

  getReportData() {
    const req1: any = {
      start_date: this.start_date,
      end_date: this.end_date,
      rep_name: this.rep_name,
      off_rep_name: this.off_rep_name,
      issuename: this.issue_cat,
      issue_date: this.issue_date
    };

    // Main off-rep -> rep-wise data (drives first table + second page office/rep split)
    this.service.getGranthRegReportInDetailsoff(req1).subscribe((data) => {
      this.inDetailsRegReportbtoff = data || [];

      if (data && data.length > 0) {
        const firstOffRep = data[0];
        this.magil_varshachi_aajchi_stithi = Number(firstOffRep.magil_varshachi_aajchi_stithi) || 0;
        this.magil_varshyachya_ekun_jahirata = Number(firstOffRep.magil_varshyachya_ekun_jahirata) || 0;
        this.officeAdvt = Number(firstOffRep.Udishta_8) || 0;
      }

      this.netadvtamt = 0;
      this.totalgst = 0;
      this.totalbeforegst_amt = 0;
      this.jamatotal = 0;
      this.totalCopiesSum = 0;
      this.totalBookPriceSum = 0;
      this.totalSalePriceSum = 0;
      this.totalShippingSum = 0;

      for (let offRepData of this.inDetailsRegReportbtoff) {
        offRepData.total_advt_amt = 0;
        offRepData.total_net_amt = 0;
        offRepData.total_before_gst_amt = 0;
        offRepData.total_gst_amt = 0;
        offRepData.total_amount = 0;
        offRepData.total_copies = 0;
        offRepData.total_book_price = 0;
        offRepData.total_sale_price = 0;
        offRepData.total_shipping_charges = 0;
        offRepData.total_received_amt = 0;
        offRepData.total_pending = 0;

        if (offRepData.rep_data && offRepData.rep_data.length > 0) {
          for (let repData of offRepData.rep_data) {
            repData.udhistha = repData.udishta_column || 0;

            offRepData.total_advt_amt += parseFloat(repData.total_advt_amount) || 0;
            offRepData.total_net_amt += parseFloat(repData.total_discounted_amt) || 0;
            offRepData.total_before_gst_amt += parseFloat(repData.total_before_gst) || 0;
            offRepData.total_gst_amt += parseFloat(repData.total_gst) || 0;
            offRepData.total_amount += parseFloat(repData.total_amount) || 0;
            offRepData.total_copies += parseFloat(repData.total_copies) || 0;
            offRepData.total_book_price += parseFloat(repData.total_book_price) || 0;
            offRepData.total_sale_price += parseFloat(repData.total_sale_price) || 0;
            offRepData.total_shipping_charges += parseFloat(repData.total_shipping_charges) || 0;
            offRepData.total_received_amt += parseFloat(repData.total_recipt_amt) || 0;
            offRepData.total_pending += parseFloat(repData.total_pending) || 0;
          }
        }

        this.totalbeforegst_amt += offRepData.total_before_gst_amt;
        this.totalgst += offRepData.total_gst_amt;
        this.netadvtamt += offRepData.total_amount;
        this.jamatotal += offRepData.total_received_amt;
        this.totalCopiesSum += offRepData.total_copies;
        this.totalBookPriceSum += offRepData.total_book_price;
        this.totalSalePriceSum += offRepData.total_sale_price;
        this.totalShippingSum += offRepData.total_shipping_charges;
      }

      this.inDetailsRegReportbtoff101 = JSON.parse(JSON.stringify(this.inDetailsRegReportbtoff));

      this.calculateTotalUdhistha();
      this.separateOfficeRepData(data);
    });

    // Briefly totals (Advt Amt / Net Amt / Received) shown in first table footer
    this.service.getRegReportBriefly(req1).subscribe((data) => {
      this.advtamtb = 0;
      this.totaladvtamt = 0;
      this.jamatotalb = 0;

      for (let data1 of data) {
        this.advtamtb += parseFloat(data1.advt_amt) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.jamatotalb += parseFloat(data1.pymt_rcv_amt) || 0;
      }
    });
  }

  // Splits the raw off-rep response into: regular reps (inDetailsRegReportbtoff)
  // and the special "कार्यालय - जाहिरात विभाग" (office) row, computing totals for each.
  separateOfficeRepData(data: any[]) {
    this.inDetailsRegReportbtoff = [];
    this.officeRepData = null;
    this.officeAdvt = 0;
    this.officeTotalAmt = 0;
    this.regularTotalAmt = 0;

    const isOffice = (name: string) => (name || '').toString().trim() === 'कार्यालय - जाहिरात विभाग';
    const isEkun = (name: string) => /एकून/.test((name || '').toString());

    data.forEach(item => {
      const name = (item.off_rep_name || '').toString().trim();

      if (isOffice(name)) {
        this.officeRepData = item;
        this.officeAdvt = this.parseNum(item.Udishta_8 ?? item.udishta_8 ?? 0);

        if (Array.isArray(item.rep_data) && item.rep_data.length) {
          this.officeTotalAmt = item.rep_data.reduce((s: number, r: any) => s + this.parseNum(r.total_amt ?? r.total), 0);
        } else {
          this.officeTotalAmt = this.parseNum(item.total_amt ?? item.total);
        }

        this.magil_varshachi_aajchi_stithi = item.magil_varshachi_aajchi_stithi ?? this.magil_varshachi_aajchi_stithi ?? 0;
        this.magil_varshyachya_ekun_jahirata = item.magil_varshyachya_ekun_jahirata ?? this.magil_varshyachya_ekun_jahirata ?? 0;
      } else if (isEkun(name)) {
        // skip summary rows
      } else {
        this.inDetailsRegReportbtoff.push(item);
      }
    });

    this.regularTotalAmt = this.inDetailsRegReportbtoff.reduce((sum: number, item: any) => {
      if (Array.isArray(item.rep_data) && item.rep_data.length) {
        return sum + item.rep_data.reduce((s: number, r: any) => s + this.parseNum(r.total_amt ?? r.total), 0);
      }
      return sum + this.parseNum(item.total_amt ?? item.total ?? item['TOTAL AMT']);
    }, 0);
  }

  onUdhisthaChange(index: number, value: any) {
    this.inDetailsRegReportbtoff[index].udhistha = Number(value) || 0;
    this.gsiValues = this.inDetailsRegReportbtoff.slice(0, 7).map(item => Number(item.udhistha) || 0);
    this.calculateTotalUdhistha();
  }

  calculateTotalUdhistha() {
    this.totalUdhistha = (this.inDetailsRegReportbtoff || []).reduce(
      (sum, item) => sum + (Number(item.udhistha) || 0),
      0
    );
  }

  get totalUdhisthaPercent(): number {
    if (!this.totalUdhistha) {
      return 0;
    }
    return (this.netadvtamt / this.totalUdhistha) * 100;
  }

  saveAll() {
    const payload: any = {
      issue_name: this.newissuedatepp,
      issue_date: this.issuedatepp,
    };

    this.gsiValues.slice(0, 7).forEach((val, idx) => {
      payload[`Udishta_${idx + 1}`] = val;
    });

    payload.office_advt = this.officeAdvt;
    payload.magil_varshi_ajchi_sthiti = this.magil_varshachi_aajchi_stithi;
    payload.magil_varsh_ekun_jahirat = this.magil_varshyachya_ekun_jahirata;

    this.service.saveAllRowsGranth(payload).subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          alert('Saved successfully!');
        } else {
          alert('Error saving data.');
        }
      },
      error: (err: any) => {
        alert('Error saving data. Please try again.');
        console.error('Error saving', err);
      }
    });

    this.saveAllUdhistha();
  }

  saveAllUdhistha() {
    const payloadData = [];

    this.inDetailsRegReportbtoff101.forEach(offRep => {
      offRep.rep_data.forEach(rep => {
        payloadData.push({
          rep_name: rep.rep_name,
          udhistha: Number(rep.udhistha || rep.udishta_column || 0),
          status: rep.status ? 1 : 0
        });
      });
    });

    if (payloadData.length === 0) {
      alert('No udhistha values to save!');
      return;
    }

    this.service.saveGranthAllUdhistha(
      payloadData
    ).subscribe(
      (response) => {
        this.inDetailsRegReportbtoff101.forEach(offRep =>
          offRep.rep_data.forEach(rep => rep.status = 1)
        );
        alert('Rep-wise Udhistha Saved Successfully!');
      },
      (error) => {
        alert('Error: ' + (error.error?.message || error.message));
      }
    );
  }

  exportexcel(fileName: string): void {
    const mainTable = document.getElementById('print-section');
    const footerTable = document.querySelector('.second-page-table');

    if (!mainTable) {
      console.error('Main table not found!');
      return;
    }

    try {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.table_to_sheet(mainTable);

      if (footerTable) {
        const footerWs = XLSX.utils.table_to_sheet(footerTable);
        const footerData = XLSX.utils.sheet_to_json(footerWs, { header: 1 });
        XLSX.utils.sheet_add_json(ws, footerData, { skipHeader: true, origin: -1 });
      }

      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

  printPageA4Portrait() {
    const printContents = document.getElementById('print-section')?.innerHTML || '';
    let secondPageContents = document.querySelector('.second-page-table')?.outerHTML || '';

    const inputs = document.querySelectorAll('.second-page-table input');
    const inputValues = {};
    inputs.forEach((input, index) => {
      inputValues[index] = (input as HTMLInputElement).value;
    });

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = secondPageContents;

    const tempInputs = tempDiv.querySelectorAll('input');
    tempInputs.forEach((input, index) => {
      const value = inputValues[index] || '';
      const span = document.createElement('span');
      span.textContent = value;
      span.style.fontWeight = 'bold';
      span.style.textAlign = 'right';
      span.style.display = 'inline-block';
      span.style.width = '100%';
      input.parentNode.replaceChild(span, input);
    });

    secondPageContents = tempDiv.innerHTML;

    const printWindow = window.open('', '_blank', 'width=794,height=1123');

    if (printWindow) {
      printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Print Report</title>
        <style>
          @page {
            size: A4 portrait;
            margin: 10mm 8mm 10mm 8mm;
          }

          @media print {
            body {
              font-family: Arial, sans-serif;
              font-size: 13px;
              line-height: 1.2;
              margin: 0;
              padding: 0;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }

            table {
              border-collapse: collapse;
              width: 100%;
              page-break-inside: avoid;
            }

            th, td {
              border: 1px solid #000 !important;
              padding: 4px 6px !important;
              font-size: 13px !important;
              vertical-align: middle;
            }

            .table-bordered th,
            .table-bordered td {
              border: 1px solid #000 !important;
            }

            .yellow,
            [style*="background-color: yellow"],
            [style*="background-color:#e7e709"] {
              background-color: #ffff00 !important;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }

            [style*="background-color: #8ed9dd"] {
              background-color: #8ed9dd !important;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }

            [style*="background-color: #f8f9fa"] {
              background-color: #f8f9fa !important;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }

            .noPrint,
            button,
            .btn {
              display: none !important;
            }

            .second-page-table {
              page-break-before: always;
              margin-top: 0;
            }

            th {
              font-weight: bold !important;
              text-align: center;
            }

            [style*="text-align: center"] {
              text-align: center !important;
            }

            [style*="text-align: end"],
            [style*="text-align: right"] {
              text-align: right !important;
            }

            [style*="text-align: left"] {
              text-align: left !important;
            }

            input {
              border: none !important;
              background: transparent !important;
              font-weight: bold !important;
              text-align: right !important;
              width: 100% !important;
              padding: 0 !important;
              margin: 0 !important;
            }

            div {
              margin: 0;
              padding: 0;
            }

            #print-section {
              margin: 0;
              padding: 0;
              display: block;
            }

            #print-section table {
              width: 100%;
              margin: 0 auto;
            }

            .second-page-table table {
              width: 60%;
              margin: 20px auto;
            }

            .second-page-table .second-page-header {
              font-size: 24px !important;
              font-weight: bold !important;
              text-align: center !important;
              padding: 8px !important;
            }
          }

          @media screen {
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }

            table {
              border-collapse: collapse;
              margin: 20px auto;
            }

            th, td {
              border: 1px solid #000;
              padding: 8px;
            }

            th {
              font-size: 20px;
            }

            td {
              font-size: 12px;
            }

            .yellow {
              background-color: #ffff00;
            }
          }
        </style>
      </head>
      <body>
        <div id="print-section">
          ${printContents}
        </div>
        ${secondPageContents}
      </body>
      </html>
    `);

      printWindow.document.close();

      printWindow.onload = function () {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }, 500);
      };
    }
  }
}